import InviteFriendsPlay from './InviteFriendsPlay';
export default  InviteFriendsPlay;